import { create } from 'zustand';
import { devtools /*, persist*/ } from 'zustand/middleware';
import { StateCreatorWithDevtools } from './store-utils';

// TODO: Full reset of the store when the user exit the unreistricted ticket selection component.

// INFO: New sale

export interface BaseSiteStore {

    integ: string,
    setInteg: (integ: string) => void;

    //clientTracking: ClientTracking,
    //setClientTracking: (clientTracking: ClientTracking) => void;
    // Current language?
}



const BaseSiteStoreDef: StateCreatorWithDevtools<BaseSiteStore, BaseSiteStore> = (set, _get) => {
    return {
        // ****************
        // States
        // ****************
        integ: "",
        setInteg: (integ: string) => set({ integ }, false, {type: 'setInteg', integ }),

        // ****************
        // Actions
        // ****************
    };
}


export const useBaseSiteStore = create<BaseSiteStore>()(
    devtools(BaseSiteStoreDef, { name: 'BaseSiteStoreDef', store: 'BaseSiteStoreDef' })
    // Add different middleware here like "devtools" or "persist"
);
